import { Controller } from "@hotwired/stimulus"

// Persist the open/closed state of an admin-sidebar <details> group
// across navigations via localStorage. Auto-expand still wins on first
// load (when the current controller is one of the group's children) —
// after that, user's manual toggle is remembered.
//
// Wire on a <details> element:
//   <details data-controller="sidebar-group"
//            data-sidebar-group-key-value="sync"
//            data-sidebar-group-default-open-value="<%= sync_open %>">
export default class extends Controller {
  static values = {
    key: String,
    defaultOpen: Boolean,
  }

  connect() {
    console.log(`[sidebar-group] connect: key=${this.keyValue} defaultOpen=${this.defaultOpenValue}`)
    this.storageKey = `sidebar.group.${this.keyValue}.open`

    // If the user has a stored preference, honor it. Otherwise use the
    // default (server-side: auto-expand when current page is a child).
    const stored = localStorage.getItem(this.storageKey)
    if (stored === "true")  this.element.open = true
    if (stored === "false") this.element.open = false
    // If no stored value, the <details open> attribute from the server
    // already provides the default — leave alone.

    this.element.addEventListener("toggle", this.persist)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.persist)
  }

  persist = () => {
    try {
      localStorage.setItem(this.storageKey, this.element.open ? "true" : "false")
    } catch (e) {
      console.warn("[sidebar-group] localStorage write failed:", e)
    }
  }
}
